export default "__VITE_ASSET__huQ7y2km__"